import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import { allFilterPages, generateOrderDashboardParams } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

import { getOrderDashboardFilterOptionSearch } from '@services/orderDashboard';

const PoNumber = ({ filterPageName, showFilter }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [search, setSearch] = useState('');
	const debounceSearch = useDebouncedCallback((text) => setSearch(text), 500);
	const orderDashboardFilterFields = useSelector((store) => store.filterFieldStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.MY_ORDER]: dependentFilterList?.poNumberList
	};
	const onFetchData = async () => {
		let responseData = filterData[filterPageName] || [];
		responseData = responseData?.map((item) => {
			return { id: item.name, name: item.name, ...item };
		});
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		debounceSearch(e.target.value);
	};

	useEffect(() => {
		if (showFilter) {
			(async () => {
				let orderQuery = generateOrderDashboardParams(orderDashboardFilterFields);
				const data = await getOrderDashboardFilterOptionSearch(
					`?filterType=PO_NUMBER&search=${search}${orderQuery}`
				);
				let responseData = data?.map((item) => {
					return { id: item.name, name: item.name, ...item };
				});
				setData(responseData);
			})();
		}
	}, [search, showFilter]);

	return (
		<>
			<FilterName type="PO_NUMBER" />
			<Checkbox data={data} type="PO_NUMBER" handleSearch={handleSearch} />
		</>
	);
};

export default PoNumber;
